// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__yr1_s","left":"InfoRow_left__VX7q3"};